import { stripHtml } from '@/lib/schema/utils'

function hasText(value) {
  return Boolean(stripHtml(value || ''))
}

function hasOwnContentBlock(blocks = []) {
  return blocks.some((block) => {
    const data = block?.data || {}

    if (
      hasText(data.title) ||
      hasText(data.content) ||
      hasText(data.description) ||
      hasText(data.text) ||
      hasText(data.short_content)
    ) {
      return true
    }

    if (data.image || data.video || data.link) {
      return true
    }

    if (Array.isArray(data.images) && data.images.length > 0) {
      return true
    }

    return false
  })
}

/**
 * Thin direction/subdirection pages without active services
 * and without own description / content blocks should be noindex,follow.
 */
export default function shouldNoIndexDirection({
  services = [],
  short_content = '',
  blocks = [],
} = {}) {
  const hasActiveServices = Array.isArray(services) && services.length > 0
  const hasOwnDescription = hasText(short_content) || hasOwnContentBlock(blocks)

  return !hasActiveServices && !hasOwnDescription
}
